import { formatToCurrency } from "shared/utils";
import { HousingAssistanceAdjustedActivity } from "../types";
import { RoleTitles } from "views/settings-users/slices/users/constants";

export const HousingAssistanceAdjusted = ({
  activity
}: {
  activity: HousingAssistanceAdjustedActivity;
}) => {
  const author = activity.author?.name ?? activity.author?.email;
  const authorRole: string =
    RoleTitles[activity.author?.author_role ?? ""] ?? "";
  return (
    <div>
      <p>
        <span className="font-bold">Monthly housing assistance edited</span>
        {author && ` by ${author} `}
        {authorRole && ` (${authorRole})`}
      </p>
      <p className="text-sm text-content-400 mt-2">
        Previous amount ({formatToCurrency(activity.details.old_amount)}) → New
        amount ({formatToCurrency(activity.details.new_amount)})
      </p>
    </div>
  );
};
